/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_BlogInputs */

const en_footer_blog = /** @type {(inputs: Footer_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const zh_hans1_footer_blog = /** @type {(inputs: Footer_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`博客`)
};

const pt_br2_footer_blog = /** @type {(inputs: Footer_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const es_footer_blog = /** @type {(inputs: Footer_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const fr_footer_blog = /** @type {(inputs: Footer_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const de_footer_blog = /** @type {(inputs: Footer_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const ru_footer_blog = /** @type {(inputs: Footer_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Блог`)
};

const it_footer_blog = /** @type {(inputs: Footer_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Footer_BlogInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_blog = /** @type {((inputs?: Footer_BlogInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_BlogInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_blog(inputs)
	if (locale === "pt-BR") return pt_br2_footer_blog(inputs)
	if (locale === "es") return es_footer_blog(inputs)
	if (locale === "fr") return fr_footer_blog(inputs)
	if (locale === "de") return de_footer_blog(inputs)
	if (locale === "ru") return ru_footer_blog(inputs)
	if (locale === "it") return it_footer_blog(inputs)
	return en_footer_blog(inputs)
});